const _KeyCodes = {
  ENTER: 13,
};

export default class Keyboard {
  static get KeyCode() {
    return _KeyCodes;
  }
}
